export const ptCommon = {
  // ... existing translations ...
  "welcome": "Bem-vindo ao GRUPO FR",
  "description": "Seu parceiro de confiança em imóveis",
  "exploreProperties": "Explorar Propriedades",
  "ourServices": "Nossos Serviços",
  "featuredProperties": "Propriedades em Destaque",
  "aboutUs": "Sobre Nós",
  "contactUs": "Entre em Contato",
  "allRights": "Todos os direitos reservados",
  "propertySales": "Venda de Propriedades",
  "propertyRentals": "Aluguel de Propriedades",
  "propertyManagement": "Gestão de Propriedades",
  "realEstateConsulting": "Consultoria Imobiliária",
  "propertyValuation": "Avaliação de Propriedades",
  "legalSupport": "Suporte Jurídico",
  "adminPanel": "Painel Administrativo",
  "language": "Idioma",
  
  // Search functionality
  "propertyType": "Tipo de Propriedade",
  "location": "Localização",
  "status": "Status",
  "forSale": "À Venda",
  "forRent": "Para Alugar",
  "advancedSearch": "Busca Avançada",
  "priceRange": "Faixa de Preço",
  "minPrice": "Preço Mín.",
  "maxPrice": "Preço Máx.",
  "bedrooms": "Quartos",
  "bathrooms": "Banheiros",
  "area": "Área",
  "minArea": "Área Mín.",
  "any": "Qualquer",
  "reset": "Limpar",
  "apartment": "Apartamento",
  "house": "Casa",
  "condo": "Condomínio",
  "office": "Escritório",
  "commercial": "Comercial",
  
  // Compare functionality
  "compareProperties": "Comparar Propriedades",
  "properties": "Propriedades",
  "characteristics": "Características",
  "noPropertiesToCompare": "Nenhuma propriedade para comparar",
  "selectPropertiesToCompare": "Selecione propriedades para comparar suas características",
  "remove": "Remover",
  "yearBuilt": "Ano de Construção",
  "parking": "Estacionamento",
  "floor": "Andar",
  "furnished": "Mobiliado",
  "yes": "Sim",
  "no": "Não",
  "features": "Características",
  "more": "mais",
  "comparingProperties": "Comparando {{count}} propriedades",
  "clearAll": "Limpar Tudo",
  "close": "Fechar",
  "addToCompare": "Adicionar para Comparar",
  "removeFromCompare": "Remover da Comparação",
  "compare": "Comparar",
  
  // Appointment booking
  "scheduleVisit": "Agendar Visita",
  "contactInformation": "Informações de Contato",
  "fullName": "Nome Completo",
  "enterFullName": "Digite seu nome completo",
  "email": "E-mail",
  "enterEmail": "Digite seu e-mail",
  "phone": "Telefone",
  "enterPhone": "Digite seu telefone",
  "selectDateTime": "Selecionar Data e Hora",
  "preferredDate": "Data Preferida",
  "selectDate": "Selecione uma data",
  "preferredTime": "Hora Preferida",
  "selectTime": "Selecione um horário",
  "additionalMessage": "Mensagem Adicional",
  "optional": "opcional",
  "enterAdditionalMessage": "Digite qualquer solicitação especial ou pergunta",
  "characters": "caracteres",
  "importantInformation": "Informações Importantes",
  "visitDuration": "A duração da visita é de aproximadamente 30-45 minutos",
  "confirmationMessage": "Você receberá confirmação por e-mail e telefone",
  "cancellationPolicy": "Você pode cancelar ou reagendar com 24 horas de antecedência",
  "cancel": "Cancelar",
  "scheduling": "Agendando...",
  "appointmentConfirmed": "Agendamento Confirmado!",
  "appointmentConfirmedMessage": "Sua visita foi agendada com sucesso. Entraremos em contato em breve.",
  "appointmentDetails": "Detalhes do Agendamento",
  "property": "Propriedade",
  "name": "Nome",
  "date": "Data",
  "time": "Hora",
  "closingAutomatically": "Esta janela fechará automaticamente...",
  "preferVoiceAssistance": "Prefere agendar por voz? Use nosso assistente inteligente",
  "talkWithAgent": "Falar com Agente",
  "bookVisit": "Agendar Visita"
};

export default ptCommon;
